<template>
  <div class="flex justify-center items-center rounded-full border-2 border-gray-500 shadow-lg bg-transparent">
    <img class="rounded-full h-full w-full object-cover" :src="avatar" :alt="name"  :class="bg" />
  </div>
</template>
<script>
import { useStore } from 'vuex'
import { computed } from 'vue'

export default {
  name: 'StudentAvatar',
  props: {
    username: String,
    bg: {
      type: String,
      default: 'block'
    },
    api: {
      type: String,
      default: 'api/avataaars'
    }
  },
  setup (props) {
    const store = useStore()

    const avatar = computed(() => props.username ? checkImage(props.username) : store.state.userAvatar)

    const name = computed(() => props.username ? props.username : store.state.userName)

    function checkImage (username) {
      let imagePath = ''
      try {
        imagePath = require(`../assets/${username}`)
      } catch (e) {
        imagePath = require('../assets/general/default-user.png')
      }
      return imagePath
    }
    return {
      name,
      avatar
    }
  }
}
</script>
